<form [formGroup]="form">
    <mat-form-field class="places-form-field" [appearance]="appearance">
        <mat-label>{{label}}</mat-label>
        <input [formControlName]="controlName" matInput [placeholder]="placeholder" #googlePlaces>
    </mat-form-field>
</form>

